(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomLogTypeAttributeDeleteController',CustomLogTypeAttributeDeleteController);

    CustomLogTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomLogTypeAttribute'];

    function CustomLogTypeAttributeDeleteController($uibModalInstance, entity, CustomLogTypeAttribute) {
        var vm = this;

        vm.customLogTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomLogTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
